export const CATEGORY_CONSTS = {
    GET_CATEGORIES: "GET_CATEGORIES",
    GET_CATEGORY_BY_ID: "GET_CATEGORY_BY_ID",
    CREATE_CATEGORY: "CREATE_CATEGORY",
    DELETE_CATEGORY_BY_ID: "DELETE_CATEGORY_BY_ID",
};
